import { CheckBoxSwitcher } from '@systemeio/ui'
import { useTranslation } from 'react-i18next'

type MoreProps = {
  checked: boolean
  toggle: (value: boolean) => void
  label?: string
}

function More({ checked, toggle, label = 'settings_options.more.label' }: MoreProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-2">
      <span>{t(label)}</span>
      <CheckBoxSwitcher selected={checked} onChange={toggle} />
    </div>
  )
}

export default More
